import React from 'react'
import { Box, makeStyles, Typography } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { Roles } from 'constants/index'

const useStyles = makeStyles({
  container: {
    position: 'sticky',
    backgroundColor: 'white',
    padding: '4px 8px',
    zIndex: 999,
    border: '1px solid white'
  }
})

const ViewHeader = ({ title, children }) => {
  const classes = useStyles()
  const user = useSelector((state) => state.auth.user)
  return (
    <Box
      className={classes.container}
      style={{
        display: 'flex',
        alignItems: 'center',
        top: user && user.role === Roles.SUPER_ADMIN ? '74px' : '100px'
      }}
      mb={4}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant="h4">{title}</Typography>
      </div>
      <span style={{ flex: 1 }} />
      {children}
    </Box>
  )
}

export default ViewHeader
